import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-text-with-images-below-component',
  templateUrl: './text-with-images-below-component.component.html',
  styleUrls: ['./text-with-images-below-component.component.css'],
})
export class TextWithImagesBelowComponentComponent {
  @Input() data!: any;
}
